import React, {useEffect, useState} from 'react';
import CCButton from '@/Atoms/CCButton';
import AntDesign from 'react-native-vector-icons/AntDesign';
import CCColors from '@/Utils/CCColors';
import customStyles from '../styles';

export const FavStar = ({
  isFav,
  gameUuid,
  callBack,
  style,
}: {
  isFav: boolean;
  gameUuid: string;
  callBack: () => void;
  style?: any;
}) => {
  const [isSelected, setIsSelected] = useState(false);

  useEffect(() => {
    setIsSelected(isFav);
  }, [isFav]);

  return (
    <CCButton
      type="none"
      onPress={() => {
        setIsSelected(prev => !prev);
        callBack?.();
      }}
      style={[
        customStyles.starBtn,
        isSelected && customStyles.starBtnActive,
        style,
      ]}>
      {isSelected ? (
        <AntDesign name="star" size={16} color={CCColors.GameReview.GoldDark} />
      ) : (
        <AntDesign
          name="staro"
          size={16}
          color={CCColors.GameReview.StarOutline}
        />
      )}
    </CCButton>
  );
};

export default FavStar;
